export default "__VITE_ASSET__df478a2b__"